import { parseCookie, stringifySetCookie } from 'cookie';

export function getCookieFromDocument(name: string) {
  const cookies = parseCookie(document.cookie);
  return cookies[name];
}

export function setCookie(
  name: string,
  value: string,
  /**
   * Expiry, in seconds. An undefined value results in a session cookie.
   * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/Cookies#removal_defining_the_lifetime_of_a_cookie
   */
  maxAge?: number
) {
  if (typeof document === 'undefined') {
    return;
  }
  const cookieString = stringifySetCookie(name, value, {
    maxAge,
    path: '/',
    sameSite: 'lax',
  });
  document.cookie = cookieString;
}

/**
 * Gets the root domain for cookie sharing across subdomains.
 * For example, 'wordpress.ihjdev.com' returns '.ihjdev.com'
 * Returns undefined for localhost or IP addresses.
 */
function getRootDomain(): string | undefined {
  if (typeof window === 'undefined') return undefined;

  const hostname = window.location.hostname;

  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    /^\d+\.\d+\.\d+\.\d+$/.test(hostname)
  ) {
    return undefined;
  }

  const parts = hostname.split('.');
  if (parts.length >= 2) {
    return '.' + parts.slice(-2).join('.');
  }

  return undefined;
}

export function setCookieForRootDomain(
  name: string,
  value: string,
  maxAge?: number
) {
  const rootDomain = getRootDomain();
  const domainPart = rootDomain ? `; domain=${rootDomain}` : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/${domainPart}; max-age=${maxAge}; SameSite=Lax`;
}
